import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Giulia F.',
  location: 'Milano, Italia'
}, {
  name: 'Marco B.',
  location: 'Roma, Italia'
}, {
  name: 'Silvia R.',
  location: 'Torino, Italia'
}, {
  name: 'Davide M.',
  location: 'Napoli, Italia'
}, {
  name: 'Laura C.',
  location: 'Bologna, Italia'
}, {
  name: 'Alessandro P.',
  location: 'Firenze, Italia'
}, {
  name: 'Francesca T.',
  location: 'Verona, Italia'
}, {
  name: 'Roberto G.',
  location: 'Genova, Italia'
}, {
  name: 'Chiara V.',
  location: 'Palermo, Italia'
}, {
  name: 'Stefano L.',
  location: 'Bari, Italia'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 16000);
    const initial = setTimeout(showPopup, 4000);
    return () => {
      clearInterval(interval);
      clearTimeout(initial);
    };
  }, []);
  return <>
      {visible && <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-191">
          <div className="bg-cream border-2 border-gold shadow-[0_0_24px_rgba(199,169,107,0.55)] rounded-xl p-2.5 pr-8 max-w-[290px] w-full relative overflow-hidden pointer-events-auto" data-id="element-192">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-gold via-sage to-gold" data-id="element-193"></div>

            <button onClick={() => setVisible(false)} aria-label="Chiudi notifica" className="absolute top-1.5 right-1.5 text-graphite/50 hover:text-graphite transition-colors" data-id="element-194">
              <XIcon className="w-4 h-4" data-id="element-195" />
            </button>

            <div className="flex items-center gap-3 mt-1" data-id="element-196">
              <div className="w-10 h-10 rounded-full bg-sage flex items-center justify-center shrink-0 shadow-md" data-id="element-197">
                <ShoppingBag className="w-5 h-5 text-white" data-id="element-198" />
              </div>
              <div className="leading-tight" data-id="element-199">
                <p className="font-bold text-petrol text-sm font-body" data-id="element-200">
                  {currentPurchase.name}
                </p>
                <p className="text-[11px] text-graphite/80 font-medium" data-id="element-201">
                  da {currentPurchase.location}
                </p>
                <p className="text-xs text-sage font-bold mt-0.5 font-body tracking-tight" data-id="element-202">
                  ha appena acquistato FITNESS SENIOR PRO™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}